<template>
  <section>
    <div class="modal is-clipped" :class="{'is-active': cancelAccount}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Cancel Account</p>
          <button class="delete" aria-label="close" @click="cancelAccount=false"></button>
        </header>
        <section class="modal-card-body">
          <div class="content">Click "Delete Account" to permanently delete your account.</div>
          <button class="button is-centered is-link" @click="deleteAccount">Delete Account</button>
          <p
            class="help is-danger"
            v-if="cancelAccountError"
          >Error deleting account. Please try again or contact support.</p>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from "../event-bus";

export default {
  data() {
    return {
      cancelAccount: false,
      cancelAccountError: false
    };
  },
  mounted: function() {
    EventBus.$on("displayCancelAccount", eventData => {
      this.cancelAccount = eventData;
    });
  },
  methods: {
    deleteAccount() {
      this.$http
        .delete(process.env.VUE_APP_API_URL + "/account")
        .then(function() {})
        .catch(function() {
          this.cancelAccountError = true;
        });

      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>
